<template>
  <div>
    <a-card style="padding-top: 22px; margin-bottom: 20px">
      <a-form-model :model="form" layout="inline" style="margin-left:160px;">
        <a-form-model-item label="机构名称">
          <a-select
            v-model="form.bureauName"
            @change="handleBureauNameSelectChange"
            style="width: 220px"
          >
            <a-select-option v-for="item in bureauNameList" :key="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="产品名称" style="margin-left:60px;">
          <a-select v-model="form.productName" style="width: 220px">
            <a-select-option
              v-for="item in disProductNameList"
              :key="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-card>
    <a-card title="新增查询">
      <div>
        <anwarida-query ref="3" v-show="form.productName === 3" />
        <anwarida-query ref="4" v-show="form.productName === 4" />
        <anwarida-query ref="6" v-show="form.productName === 6" />
        <anwarida-query ref="9" v-show="form.productName === 9" />
        <global-lookup ref="1" v-if="form.productName === 1" />
        <global-data-packet ref="2" v-show="form.productName === 2" />
        <monitor-financial-report ref="7" v-show="form.productName === 7" />
        <monitor-search-by-name ref="5" v-show="form.productName === 5" />
        <monitor-search-by-ticker ref="8" v-show="form.productName === 8" />
      </div>
    </a-card>
    <div class="footer">
      <a-button
        type="primary"
        style="margin-right: 16px"
        @click="
          $router.push({
            name: 'mechanism',
          })
        "
      >
        取消
      </a-button>
      <a-button type="primary" @click="handleClickSubmitBtn" :loading="loading">
        提交
      </a-button>
    </div>
    <a-modal
      title="提示"
      okType="danger"
      okText="继续"
      :visible="visible"
      @ok="handleOk"
      :loading="Okloading"
      @cancel="visible = false"
    >
      <span style="color:red;">付费服务</span>
      ，建议先使用查询功能，查询客户最新工商大数财报年份。是否继续本次提交申请？
    </a-modal>
  </div>
</template>
<script>
import {
  AnwaridaQuery,
  GlobalLookup,
  GlobalDataPacket,
  MonitorFinancialReport,
  MonitorSearchByName,
  MonitorSearchByTicker,
} from './components'
import { save } from './api'

const BRAZIL_VALUES = [3, 4, 6]
const BRADSTREET_GLOBAL_VALUES = [1, 2]
const CREDIT_RISK_MONITOR_VALUES = [5, 7, 8, 9]
const zcx = [9]
export default {
  data() {
    return {
      loading: false,
      Okloading: false,
      visible: false,
      show: '',
      form: {
        bureauName: 2,
        productName: 1,
      },
      productNameList: [
        {
          label: 'Lookup',
          value: 1,
        },
        {
          label: 'Global Data Packet/Report',
          value: 2,
        },
        {
          label: '查询',
          value: 3,
        },
        {
          label: '调取客户工商大数',
          value: 4,
        },
        {
          label: '调取客户详财(2年)',
          value: 6,
        },
        {
          label: 'Company Search by Name',
          value: 5,
        },
        {
          label: 'Company Search by Ticker',
          value: 8,
        },
        {
          label: 'Company Financial Report',
          value: 7,
        },
        {
          label: '财务大数报告',
          value: 9,
        },
      ],
      bureauNameList: [
        {
          label: '安华理达',
          value: 1,
        },
        {
          label: 'Dun & Bradstreet Global',
          value: 2,
        },
        {
          label: 'Credit Risk Monitor',
          value: 3,
        },
        {
          label: '中诚信',
          value: 4,
        },
      ],
    }
  },
  computed: {
    disProductNameList() {
      const bureauNameValue = this.form.bureauName
      let arr = null
      switch (bureauNameValue) {
        case 1:
          arr = this.productNameList.filter(item =>
            BRAZIL_VALUES.includes(item.value),
          )
          break
        case 2:
          arr = this.productNameList.filter(item =>
            BRADSTREET_GLOBAL_VALUES.includes(item.value),
          )
          break
        case 3:
          arr = this.productNameList.filter(item =>
            CREDIT_RISK_MONITOR_VALUES.includes(item.value),
          )
          break
        case 4:
          arr = this.productNameList.filter(item => zcx.includes(item.value))
          break
      }
      return arr
    },
  },
  components: {
    AnwaridaQuery,
    GlobalLookup,
    GlobalDataPacket,
    MonitorFinancialReport,
    MonitorSearchByName,
    MonitorSearchByTicker,
  },
  created() {
    // 处理从详情直接跳转到新增页面
    if (this.$route.query.dunsNumber) {
      this.form.productName = 2
    }
    if (this.$route.query.businessId) {
      this.form.bureauName = 3
      this.form.productName = 7
    }
    if (this.$route.query.googol) {
      this.form.bureauName = 1
      this.form.productName = 4
    }
    if (this.$route.query.detail) {
      this.form.bureauName = 1
      this.form.productName = 6
    }
    // 处理从详情直接跳转到新增页面
    if (this.$route.query.queryId) {
      this.form.bureauName = 1
      this.handleBureauNameSelectChange()
      this.form.productName = 4
      this.defaultQuery = this.$route.query.queryId
    }
  },
  methods: {
    handleOk() {
      this.visible = false
      this.Okloading = true
      this.show = '1'
      this.handleClickSubmitBtn()
      this.loading = false
    },

    async handleClickSubmitBtn() {
      const result = await this.$refs[this.form.productName].validate()
      if (result) {
        this.loading = true
        try {
          let obj = {}
          Object.keys(this.form).forEach(key => {
            let arr = []
            if (key === 'bureauName') {
              arr = this.bureauNameList
            } else {
              arr = this.productNameList
            }
            if (arr) {
              const value = arr.filter(item => item.value === this.form[key])[0]
                .label
              if (value) {
                obj[key] = value
              }
            }
          })
          if (
            (obj.productName === '调取客户工商大数' && !this.show) ||
            (obj.productName === '调取客户详财(2年)' && !this.show)
          ) {
            this.visible = true
          } else {
            let params = {
              bureauReportSettingBO: { ...result },
              ...obj,
              companyId: this.$route.params.id,
            }
            await save(params)
            this.$message.success('success')
            this.loading = false
            await this.$router.push({
              name: 'mechanism',
              params: {
                customerId: this.$route.params.id,
              },
            })
          }
        } catch (err) {
          console.error(err)
          this.loading = false
        }
      }
      this.loading = false
    },

    handleBureauNameSelectChange() {
      const bureauName = this.form.bureauName
      switch (bureauName) {
        case 1:
          this.form.productName = 3
          break
        case 2:
          this.form.productName = 1
          break
        case 3:
          this.form.productName = 5
          break

        case 4:
          this.form.productName = 9
          break
      }
    },
  },
}
</script>
<style scoped>
.footer {
  margin-top: 24px;
  text-align: right;
}
</style>
